//! The pivot panel is keyed by the report's anchor cell, written as
//! `<sheetId>!<A1>` so the atom holds a readable string rather than a
//! structure. The sheet id is part of the key because reports created on their
//! own sheets all share the same anchor cell.

import { sheets } from '@/app/grid/controller/Sheets';
import { xyToA1 } from '@/app/quadratic-core/quadratic_core';

export const pivotPanelTarget = (sheetId: string, x: number, y: number): string => `${sheetId}!${xyToA1(x, y)}`;

export const parsePivotPanelTarget = (target: string): { sheetId: string; x: number; y: number } | undefined => {
  const separator = target.indexOf('!');
  const sheetId = separator === -1 ? sheets.current : target.slice(0, separator);
  const a1 = target.slice(separator + 1);
  try {
    const jsSelection = sheets.stringToSelection(a1, sheetId);
    const cursor = jsSelection.getCursor();
    jsSelection.free();
    return { sheetId, x: Number(cursor.x), y: Number(cursor.y) };
  } catch {
    return undefined;
  }
};
